/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionGoToAddPage';

const ActionGoToAddPageManager: ActionManagerFn<'ActionGoToAddPage'> = (
  platform: Platform,
): ActionManager<'ActionGoToAddPage'> => {
  return {
    ...baseActionManager(platform, 'ActionGoToAddPage'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Go To Add Page',
    icon: { iconName: 'external-link' },
    description: `**Overview**<br/>
The "Go To Add Page" action is a specialized, system-level navigation component identified primarily for internal use within the platform. Its specific function is to initiate a navigation event that directs the user to the interface for creating or configuring a new application Page.<br/><br/>
Similar to other internal "Go To" actions, this component operates with a fixed destination determined by the platform's routing system. It does not require developer inputs for the target, as it is designed to bridge the user specifically to the page creation workflow.

**Key Features**<br/>
* **Internal Utility:** Explicitly described as a "CloudIO Internal Action," intended for use within the builder environment or administrative contexts rather than end-user applications.
* **Fixed Destination:** Functionally hardcoded to route to the "Add Page" interface.
* **Zero Configuration:** Inherits all properties directly from baseActionManager and baseActionProps without introducing any component-specific parameters.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all actions.

**Use Cases**<br/>
* **Builder Navigation:** Used within the platform's development environment to allow developers to quickly start creating a new UI page.
* **System Workflows:** Integrated into setup wizards that guide a user through the initial steps of building an application structure.`,
  };
};

export default ActionGoToAddPageManager;
